import { Country, COUNTRY_TEMPLATE } from "./country";
import { DtacBase } from "./dtac-base";

export interface Address extends DtacBase {
  street: string;
  cityName: string;
  postalCode: string;
  cityCode: string;
  country: Country;
};

export const ADDRESS_TEMPLATE: Address = {
  '@id': '',
  '@type': '',
  street: '',
  cityCode: '',
  cityName: '',
  postalCode: '',
  country: COUNTRY_TEMPLATE
};
